<template>
    <div class="p-1">
        <div v-if="cargando" class="text-center py-2 text-muted small">
            <div class="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
            Cargando detalle...
        </div>

        <dl class="detalle-grid mb-3">
            <dt>Fecha</dt>
            <dd>{{ formatFecha(registro.created_at) }}</dd>

            <dt>Admin</dt>
            <dd>
                {{ registro.admin_email || `#${registro.admin_user_id}` }}
                <span v-if="registro.admin_role_nombre" class="badge bg-light text-dark border ms-1">
                    {{ registro.admin_role_nombre }}
                </span>
            </dd>

            <template v-if="registro.impersonado_user_id">
                <dt>Como usuario</dt>
                <dd>
                    <i class="fas fa-user-secret text-warning me-1"></i>
                    {{ registro.impersonado_email || `#${registro.impersonado_user_id}` }}
                    <span v-if="registro.impersonacion_session_id" class="text-muted text-xs ms-1">
                        (sesión #{{ registro.impersonacion_session_id }})
                    </span>
                </dd>
            </template>

            <template v-if="registro.evento">
                <dt>Evento</dt>
                <dd><code>{{ registro.evento }}</code></dd>
            </template>

            <dt>Petición</dt>
            <dd>
                <span class="badge me-1" :class="claseMetodo(registro.metodo)">{{ registro.metodo }}</span>
                <code class="text-break">{{ registro.url }}</code>
                <div class="text-muted text-xs">{{ registro.ruta }}</div>
            </dd>

            <template v-if="registro.accion">
                <dt>Controlador</dt>
                <dd><code class="text-xs text-break">{{ registro.accion }}</code></dd>
            </template>

            <dt>Resultado</dt>
            <dd>
                <span class="badge" :class="registro.exito ? 'bg-success' : 'bg-danger'">
                    {{ registro.status_http }}
                </span>
                <span class="ms-2">{{ registro.mensaje_respuesta }}</span>
            </dd>

            <dt>Duración</dt>
            <dd>{{ registro.duracion_ms != null ? `${registro.duracion_ms} ms` : '—' }}</dd>

            <dt>IP</dt>
            <dd>{{ registro.ip || '—' }}</dd>

            <template v-if="registro.user_agent">
                <dt>Navegador</dt>
                <dd class="text-xs text-muted text-break">{{ registro.user_agent }}</dd>
            </template>
        </dl>

        <div v-if="tieneDatos(registro.cambios)" class="mb-3">
            <h6 class="bloque-titulo">
                Cambios en la base de datos ({{ registro.cambios.length }})
            </h6>
            <cambio-auditoria
                v-for="cambio in registro.cambios"
                :key="cambio.id"
                :cambio="cambio"
                @historial="$emit('historial', $event)"
            />
        </div>
        <p v-else-if="!cargando && registro.exito && registro.metodo !== 'GET'" class="text-xs text-muted mb-3">
            <i class="fas fa-info-circle me-1"></i>
            Esta acción no dejó cambios registrados en la base de datos.
        </p>

        <div v-if="tieneDatos(registro.parametros)" class="mb-3">
            <h6 class="bloque-titulo">Parámetros de la ruta</h6>
            <pre class="bloque-json">{{ json(registro.parametros) }}</pre>
        </div>

        <div v-if="tieneDatos(registro.payload)" class="mb-3">
            <h6 class="bloque-titulo">Datos enviados</h6>
            <pre class="bloque-json">{{ json(registro.payload) }}</pre>
            <small class="text-muted text-xxs">Los campos sensibles (contraseñas, tokens, tarjetas…) aparecen como "[OCULTO]".</small>
        </div>

        <div v-if="tieneDatos(registro.archivos)" class="mb-3">
            <h6 class="bloque-titulo">Archivos</h6>
            <pre class="bloque-json">{{ json(registro.archivos) }}</pre>
        </div>
    </div>
</template>

<script>
import { formatFecha, claseMetodo } from '../formatoAuditoria.js';
import CambioAuditoria from './cambioAuditoria.vue';

export default {
    name: 'DetalleAuditoria',
    components: { CambioAuditoria },
    props: {
        registro: { type: Object, required: true },
        cargando: { type: Boolean, default: false }
    },
    emits: ['historial'],
    setup() {
        const tieneDatos = (valor) => {
            if (valor == null) return false;
            if (Array.isArray(valor)) return valor.length > 0;
            if (typeof valor === 'object') return Object.keys(valor).length > 0;
            return valor !== '';
        };

        const json = (valor) => (typeof valor === 'string' ? valor : JSON.stringify(valor, null, 2));

        return { formatFecha, claseMetodo, tieneDatos, json };
    }
};
</script>

<style lang="scss" scoped>
.detalle-grid {
    display: grid;
    grid-template-columns: 120px 1fr;
    gap: 0.4rem 1rem;
    font-size: 0.85rem;

    dt {
        color: #8392ab;
        font-weight: 600;
    }

    dd {
        margin: 0;
        color: #344767;
        min-width: 0;
    }
}

.bloque-titulo {
    font-size: 0.8rem;
    font-weight: 700;
    color: #344767;
    margin-bottom: 0.4rem;
}

.bloque-json {
    background: #0f172a;
    color: #e2e8f0;
    border-radius: 0.5rem;
    padding: 0.75rem 1rem;
    font-size: 0.75rem;
    max-height: 320px;
    overflow: auto;
    white-space: pre-wrap;
    word-break: break-word;
    margin-bottom: 0.25rem;
}

@media (max-width: 576px) {
    .detalle-grid {
        grid-template-columns: 1fr;

        dd {
            margin-bottom: 0.4rem;
        }
    }
}
</style>
